import { bookingStore } from 'entities/booking';
import { flow, types } from 'mobx-state-tree';
import { onSnapshot } from 'mobx-state-tree';
import { axiosRequest, CustomErrorModel } from 'shared/api';
import { DoctorResponse, StaffResponse } from './types';
import { SpecializationModel } from 'entities/specializations';

const GroupModel = types.model({
  id: types.number,
  name: types.string,
})

const DefaultServiceModel = types.model({
  id: types.number,
  state: types.maybe(types.maybeNull(types.number)),
  name: types.maybe(types.maybeNull(types.string)),
  about: types.maybe(types.maybeNull(types.string)),
  indications: types.maybe(types.maybeNull(types.string)),
  preparation: types.maybe(types.maybeNull(types.string)),
  base_service: types.maybe(types.maybeNull(types.number)),
  group: types.maybe(types.maybeNull(GroupModel)),
	price_value: types.maybeNull(types.string),
	price_date: types.maybe(types.maybeNull(types.string)),
  staff: types.maybe(types.maybeNull(types.array(types.number))),
})

const ServiceModel = types.model({
	notes: types.string,
	service: DefaultServiceModel,
});

export const DoctorModel = types.model({
	id: types.number,
	full_name: types.string,
	specializations: types.array(SpecializationModel),
	speciality_experience_years: types.maybeNull(types.number),
	medical_experience_years: types.maybeNull(types.number),
	category: types.maybeNull(types.string),
	degree: types.maybeNull(types.string),
	photo: types.maybeNull(types.string),
	default_service: types.maybeNull(DefaultServiceModel),
  services: types.array(ServiceModel)
});

export const DoctorsStore = types
	.model('DoctorsStore', {
		doctors: types.array(DoctorModel),
		error: types.maybeNull(CustomErrorModel),
		loading: types.boolean,
    activeDoctor: types.maybeNull(DoctorModel)
	})
  .views(self => ({
    getActiveDoctor: () => {
      return self.activeDoctor
    },
    getDoctors: () => {
      return self.doctors;
    },
  }))
	.actions(self => ({
		fetchDoctors: flow(function* (work_date?: string) {
			try {
				self.error = null;
				self.loading = true;
				const branch = bookingStore.clinics.map(clinic => clinic.id);
				const spec = bookingStore.specialization?.id;
				if (!work_date) work_date = bookingStore.date;

				const response: StaffResponse = yield axiosRequest({
					path: '/api/v2/booking/staff',
					params: { spec, work_date, branch },
				});

				if (!response.results?.length) {
					self.error = {
						message: '',
						code: 'NOT_FOUND',
						status: 404,
					};
				}

				// response.results.push(  {
				// 	"id": 4221,
				// 	"last_name": "Шубин",
				// 	"first_name": "Федор",
				// 	"mid_name": "Григорьевич",
				// 	"full_name": "Шубин Федор Григорьевич",
				// 	"degree": null,
				// 	"category": null,
				// 	"directions": "",
				// 	"education": "",
				// 	"high_school": null,
				// 	"medical_experience": null,
				// 	"medical_experience_years": null,
				// 	"speciality_experience": null,
				// 	"speciality_experience_years": null,
				// 	"speciality": null,
				// 	"online_booking_allowed": true,
				// 	"default_service": null,
				// 	"specializations": [
				// 		{
				// 			"id": 1,
				// 			"name": "УЗИ",
				// 			"order": 10
				// 		}
				// 	],
				// 	"photo": null
				// })

				self.loading = false;
				self.doctors.replace(response.results as any);
			} catch (error) {
        console.warn(error);
				self.loading = false;
				//self.error = error as MSTCustomError;
			}
		}),
		resetDoctors: () => {
			self.doctors = [] as any;
		},
    getDoctorById: (id: number) => {
      return self.doctors.find(doctor => doctor.id === id)
    },
    fetchDoctorById: flow(function* (id: number | string) {
			try {
				self.error = null;
				self.loading = true;

				const response: DoctorResponse = yield axiosRequest({
					path: `/api/v2/booking/staff/${id}`,
				});
        
				if (!response?.id) {
					self.error = {
						message: '',
						code: 'NOT_FOUND',
						status: 404,
					};

				  self.loading = false;
          if (response) {
            return {
              isError: true,
              ...response
            }
          } else {
            return
          }
				}

        if (response?.specializations[0]) {
          bookingStore.setSpecialization(response?.specializations[0])
          // bookingStore.setClinics([]);
          // localStorage.setItem('specialization', JSON.stringify(response?.specializations[0]))
        }

				self.error = null;
				self.loading = false;
				self.activeDoctor = response as any;

        return response;
			} catch (error) {
        console.warn(error);
				self.loading = false;
				//self.error = error as MSTCustomError;
			}
    }),
    searchDoctors: flow(function* (query: string) {
			try {
				self.error = null;
				self.loading = true;

				const response: StaffResponse = yield axiosRequest({
					path: `/api/v2/booking/staff?search=${query}`,
				});

        return response?.results || [];
			} catch (error) {
        console.warn(error);
				self.loading = false;
				//self.error = error as MSTCustomError;

        return []
			}
    })
	}));

export const doctorsStore = DoctorsStore.create({
	doctors: [],
	error: null,
	loading: false,
  activeDoctor: null
});

//Если нужно дебажить
onSnapshot(doctorsStore, snapshot => {
  if (import.meta.env.VITE_SHOW_SNAPSHOT !== 'false') {
    console.log('Снимок состояния врачи:', snapshot);
  }
});

// onAction(documentsStore, action => {
// 	console.log("Экшен", action);
// })
